export enum ParameterType {
    params = 'PARAMS',
    query = 'QUERY',
    local_storage = "localStorage"
}